import {
  EncounterTemplateControllerApi,
  PhysicalROSTemplateRequest,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useRosPeTemplateUpdate = () =>
  useMutationWithLoading(
    async (params: {
      physicalROSTemplateRequest: PhysicalROSTemplateRequest;
      xTENANTID?: string;
    }) =>
      new EncounterTemplateControllerApi(
        getConfigObject()
      ).updateEncounterTemplate(
        params.physicalROSTemplateRequest,
        params.xTENANTID
      )
  );
